import { IUserRole } from '../interfaces';

const userRoleAdapter = (roleId: number): IUserRole => {
  if (roleId === 1) return 'admin';
  if (roleId === 2) return 'agent';
  if (roleId === 3) return 'customer';
  if (roleId === 4) return 'shareholder';
  return 'customer';
};

export { userRoleAdapter };
